import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=4e5bb091&scoped=true&"
import script from "./Conference.vue?vue&type=script&lang=js&"
export * from "./Conference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5bb091",
  null
  
)

export default component.exports